module.exports = __webpack_public_path__ + "img/slider_banner_2.038bbeab.jpg";